import type { NetworkParams } from './types'

export const match = (hostname: string): boolean => /tidd\.ly/.test(hostname)
export const compactTracking = true
export const maxTrackingLength = 50

export const apply = (url: URL, params: NetworkParams): void => {
  if (params.trackingId) {
    url.searchParams.set('xcust', params.trackingId)
    return
  }

  const value = params.content
    ? `co=${params.content}|${params.utmSearch}|t=${params.term}`
    : `${params.utmSearch}|t=${params.term}`
  url.searchParams.set('xcust', value)
}
